import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { DevicesTable } from "@/features/devices/components/DevicesTable"

// 2026-04-24 — deep-link: `?id=<guid>` URL paramı verildiğinde ilgili cihazın
// detay drawer'ı otomatik açılır. Satır tıklaması URL'i senkronize eder.
// 2026-06-30 — `?orgId=<id>` (ADR #027): org yönetim ekranından "Cihazları Gör"
// deep-link'i listeyi o org'un alt ağacına daraltır (server subtree ile kesişir).
const searchSchema = z.object({
  id: z.string().optional(),
  orgId: z.string().optional(),
})

export const Route = createFileRoute("/_authed/devices")({
  component: DevicesPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function DevicesPage() {
  const { t } = useTranslation("devices")
  const { id, orgId } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <DevicesTable initialSelectedId={id ?? null} orgIdOverride={orgId ?? null} />
    </div>
  )
}
